const fourOneSchema = {
  title: "4_1 Goods Purchased by an Organization",
  addAPI: "cat4_1AddEmissionActivityAPI",
  cat: "cat4_1",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "goodsName",
      level: 1,
      type: "input",
      label: "Purchased Good Name / Type",
      resetOnChange: false,
      required: true,
    },
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Raw Material Type",
      optionsAPI: "goodsPurchasedByAnOrganizationRawMaterialTypeAPI",
      required: false,
    },
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Supplier Name",
      resetOnChange: false,
      required: false,
    },
  ],
};

export default fourOneSchema;
